<template>
  <div class="page">
    <slot />
  </div>
</template>

<script setup lang="ts">
useSetScreenValues()
</script>
